import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class CreateAgreementOwnershipPremiumSplit extends Component {
  constructor() {
    super();
    this.state = { name: '' };
  }

  componentWillMount() {
    if (this.props.agreement) {
      this.setState({ name: this.props.agreement.name });
    }
  }

  handleName(e) {
    this.setState({ name: e.target.value });
  }

  handleKeydown(e) {
    if (e.keyCode === 13) {
      this.handleNext();
    }
  }

  handleNext() {
    // const { fields } = this.props;
    const { name } = this.state;

    this.props.hideAlert();

    if (name === '') {
      this.props.alert('error', 'Please name this agreement.');
      return false;
    }

    this.props.assignAttribute('premiumSplitName', name);
    this.props.assignAttribute('soundRecordingType', 'ownership');

    this.props.router.push(
      '/create/agreement-ownership-percentage/premium-split'
    );
    // if (parseInt(fields.subtype, 10) === 1) {
    //   // WorkSubType is "Sound Recording"
    //   this.props.router.push('/create/agreement-sound-recording-split-type/premium-split');
    // } else {
    //   this.props.router.push('/create/agreement-ownership-percentage/premium-split');
    // }
  }

  handlePrev() {
    this.props.router.push('/create/select-agreement');
  }

  render() {
    return (
      <div className="create-agreement">
        <Heading text="New Agreement" />
        <div className="content">
          <form>
            <FormGroup controlId="agreement-name">
              <FormControl
                ref="agreementName"
                type="text"
                className="agreement-name-input"
                value={this.state.name}
                placeholder="Agreement name"
                onChange={(e) => this.handleName(e)}
                onKeyDown={(e) => this.handleKeydown(e)}
              />
            </FormGroup>
          </form>
        </div>
        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  agreement: state.agreements.selectedAgreement,
  fields: state.create.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAgreementOwnershipPremiumSplit);



// WEBPACK FOOTER //
// src/components/Agreements/CreateAgreementOwnershipPremiumSplit.jsx